import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    Button,
    Popover
} from '@material-ui/core'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'

import { ColorPaper } from '../Atoms'

const useStyles = makeStyles(theme => ({
    button: {
        color: theme.palette.primary.main
    },
}))

const FilterPopover = ({ title, className, disabled, children }) => {
    const classes = useStyles()
    const paddingWrapper = React.useRef()
    const [open, setOpen] = React.useState(false)

    const handleClick = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const id = open ? 'simple-popover' : undefined

    return (
        <div style={{ display: 'inline-block' }} className={className}>
            <div
                ref={paddingWrapper}
                style={{ paddingBottom: 5 }}
            >
                <Button
                    aria-describedby={id}
                    variant="outlined"
                    color="primary"
                    onClick={handleClick}
                    className={classes.button}
                    disabled={disabled}
                >
                    {title} {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </Button>
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={paddingWrapper.current}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                PaperProps={{
                    component: 'div',
                    elevation: 0,
                }}
            >
                <ColorPaper
                    style={{
                        padding: 20,
                        minWidth: 200,
                    }}
                    elevation={0}>

                    {children}
                </ColorPaper>
            </Popover>
        </div >
    )
}

export default FilterPopover